<div class="md:h-[calc(100vh-84px)] h-[calc(100vh-133px)] flex flex-col justify-between"
    *transloco="let t; prefix: 'payment.wizard'">
    <!-- Stepper -->
    <div class="container flex pt-10">
        <progress-stepper [StepNo]="stepCounter" [Steps]="steps" />
    </div>
    <!-- END OF Stepper -->

    <!-- Body -->
    <div class="flex flex-1 w-full self-start overflow-y-auto md:pt-20 pt-14 px-2">
        <ng-container [ngSwitch]="stepCounter">
            <app-step-one *ngSwitchCase="1" class="flex flex-col flex-1 rfs:gap-14 items-center" />
            <app-step-two *ngSwitchCase="2" class="flex flex-col flex-1 rfs:gap-14 items-center" />
            <app-step-three *ngSwitchCase="3" class="flex flex-col flex-1 rfs:gap-14 items-center" />
            <app-step-four *ngSwitchCase="4" class="flex flex-col flex-1 rfs:gap-14 items-center" />
        </ng-container>
    </div>
    <!-- END OF Body -->

    <!-- Wizard navigation (previous/next) -->
    <div class="flex w-full">
        <app-navigation-buttons class="flex-1" [HideSkip]="true"
            [HidePrevious]="hidePrevious"
            (PreviousButtonClicked)="onPrevClick()"
            (NextButtonClicked)="onNextClick()" [CustomNextTitle]="t(customNextTitle)"/>
    </div>
    <!-- END OF Wizard navigation (previous/next) -->
</div>